module.exports = __webpack_public_path__ + "img/Icon map-food.28572af6.svg";